import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppServiceService } from 'src/app/app-service.service';
import { Customer, Unit, UserDetailsMainModel } from 'src/app/user-details-model';
import { UmMaintenanceService } from 'src/app/user-module/um-maintenance/um-maintenance.service';

//import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-equipment-status-details',
  templateUrl: './equipment-status-details.component.html',
  styleUrls: ['./equipment-status-details.component.scss']
})
export class EquipmentStatusDetailsComponent implements OnInit , OnDestroy {
  @Input('showEquipmentPopUp') showEquipmentPopUp: boolean = false;
  @Output('onPopUpClose') onPopUpClose = new EventEmitter<boolean>();
  subscriptionEquipmentDetails: Subscription;
  lstEquipmentDetails: any[] = [];
  userDetails: UserDetailsMainModel;
  selectedCustomer: Customer;
  selectedUnit: Unit;

  constructor(private umMaintenanceService: UmMaintenanceService,private appService: AppServiceService,) { }

  ngOnInit(): void {
    this.appService.userDetails.subscribe(d => this.userDetails = d);
    this.appService.selectedCustomer.subscribe(d => this.selectedCustomer = d);
    this.appService.selectedUnit.subscribe(d => this.selectedUnit = d);
  }

  ngOnDestroy() {
    if (this.subscriptionEquipmentDetails) {
      this.subscriptionEquipmentDetails.unsubscribe();
    }
  }

  onShow() {
    this.lstEquipmentDetails = [];
    this.subscriptionEquipmentDetails = this.umMaintenanceService.GetAllEquipmentStatusDetailsCount(this.selectedUnit.id).subscribe(
      (response: any) => {
        if (response != null) {
          this.lstEquipmentDetails = response;
        }
      },
      error => {
      }
    );
  }

  onHide() {
    this.onPopUpClose.emit(true);
  }

}
